document.addEventListener(`DOMContentLoaded`, () => {
    const overlayToggles = document.querySelectorAll("[data-toggle='top-bar-overlay']");
    for (const toggle of overlayToggles) {
        toggle.addEventListener("click", () => {
            const body = document.querySelector("body");
            const logo = document.querySelector(".logo-image-overlay");
            const overlay = document.querySelector(".top-bar-overlay");
            const overlayItems = overlay.querySelectorAll("li");
            if (overlay.classList.contains("visible")) {
                body.classList.remove("overlay-visible");
                overlay.classList.remove("visible");
                logo.classList.remove("fadeInUp");
                for (const li of overlayItems) {
                    li.classList.remove("fadeInUp");
                }
            } else {
                body.classList.add("overlay-visible");
                overlay.classList.add("visible");
                logo.classList.add("fadeInUp");
                for (const li of overlayItems) {
                    li.classList.add("fadeInUp");
                }
            }
        });
    }
});
